import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../store/store-keys'
import { ICommandPaletteState } from './command-palette.reducers'

export const selectCommandPaletteFeature =
    createFeatureSelector<Readonly<ICommandPaletteState>>(StoreKeysEnum.CommandPalette)

export const selectCommandPaletteIsOpen = createSelector(
    selectCommandPaletteFeature,
    (state) => state.isOpen
)